<template>
    <div>
        <a-modal v-model="viewModal" :closable="false" :maskClosable="false" title="Engagement Edit">
            <a-card :style="{ backgroundColor: '#E9F8F9' }" :bordered="false">
                <a-row class="mt-10 mb-10">
                    <a-col :span="6">
                        <p class="text-center mt-5 mb-0 font-bold">
                            Activity Name :
                        </p>
                    </a-col>
                    <a-col :span="18" :style="{ textAlign: 'center' }">
                        <p class="mt-5 mb-5 font-bold">
                            {{ formData? formData.activity_name: '' }}
                        </p>
                    </a-col>
                </a-row>
                <a-row class="mt-10 mb-10">
                    <a-col :span="6">
                        <p class="text-center mt-5 mb-0 font-bold">
                            Student ID :
                        </p>
                    </a-col>
                    <a-col :span="18" :style="{ textAlign: 'center' }">
                        <p class="mt-5 mb-5 font-bold">
                            {{ formData.std_id }}
                        </p>
                    </a-col>
                </a-row>
                <a-row class="mt-10 mb-10">
                    <a-col :span="6">
                        <p class="text-center mt-5 mb-0 font-bold">
                            Name :
                        </p>
                    </a-col>
                    <a-col :span="18" :style="{ textAlign: 'center' }">
                        <p class="mt-5 mb-5 font-bold">
                            {{ formData.std_name }}
                        </p>
                    </a-col>
                </a-row>
            </a-card>
            <a-row class="mt-10 mb-10">
                <a-col :span="6">
                    <p class="text-center mt-5 mb-0 font-bold">
                        Fee
                    </p>
                </a-col>
                <a-col :span="18">
                    <a-input type="number" v-model="formData.donation_fee" placeholder="" />
                </a-col>
            </a-row>
            <a-row class="mt-10 mb-10">
                <a-col :span="6">
                    <p class="text-center mt-5 mb-0 font-bold">
                        Sponsorship
                    </p>
                </a-col>
                <a-col :span="18">
                    <a-input type="number" v-model="formData.donation_sponsorship" placeholder="" />
                </a-col>
            </a-row>
            <a-row class="mt-10 mb-10">
                <a-col :span="6">
                    <p class="text-center mt-5 mb-0 font-bold">
                        Charity
                    </p>
                </a-col>
                <a-col :span="18">
                    <a-input type="number" v-model="formData.donation_charity" placeholder="" />
                </a-col>
            </a-row>

            <a-row class="mt-10 mb-10">
                <a-col :span="6">
                    <p class="text-center mt-5 mb-0 font-bold">
                        Item (s)
                    </p>
                </a-col>
                <a-col :span="18">
                    <a-button type="dashed" block @click="addItemEdit">
                        <!-- <PlusOutlined /> -->
                        + Add Item
                    </a-button>
                </a-col>
            </a-row>

            <span v-for="(item, index) in formData.items" :key="'a' + index">
                <a-row class="mt-10 mb-0">
                    <a-col :span="6"> </a-col>
                    <a-col :span="8">
                        <a-input v-model="item.item_detail" placeholder="name" />
                    </a-col>
                    <a-col :span="6" offset="1">
                        <a-input v-model="item.amount" placeholder="amount" />
                    </a-col>
                    <a-col :span="2">
                        <a-button type="link" class="text-center" @click="onRemoveItem(item, index)">
                            <a-icon style="font-size: 20px; color: red" type="delete" />
                        </a-button>
                    </a-col>
                </a-row>
            </span>

            <a-row class="mt-20 mb-10">
                <a-col :span="6">
                    <p class="text-center mt-5 mb-0 font-bold">
                        Role and Duty in the Activity
                    </p>
                </a-col>
                <a-col :span="18">
                    <a-select style="width:100%" show-search placeholder="select reason type ..."
                        option-filter-prop="children" v-model="formData.role_and_duty">
                        <a-select-option v-for="(item, index) in optionRoleAndDuty" :key="index" :value="item.value">
                            {{ item.text }}
                        </a-select-option>
                    </a-select>
                </a-col>
            </a-row>

            <a-row v-if="formData.role_and_duty === 8" class="mt-10 mb-10">
                <a-col :span="6"> </a-col>
                <a-col :span="18">
                    <a-form-item label="" extra="Please Specify other Role and Duty ">
                        <a-input v-model="formData.other_role" placeholder="" />
                    </a-form-item>
                </a-col>
            </a-row>
            <template slot="footer">
                <a-button key="back" @click="onCloseModal()"> Close pop-up </a-button>
                <a-button key="submit" type="primary" :disabled="!isLoaded" :loading="!isLoaded"
                    @click="onUpdateEngagement">
                    Update Engagement
                </a-button>
            </template>
        </a-modal>
    </div>
</template>
<script>
const formDefault = {
    donation_fee_type: "fee",
    donation_fee: 0,
    donation_sponsorship: 0,
    donation_charity: 0,
    role_and_duty: "",
    other_role: "",
    items: [],
};
export default {
    props: //['viewModal', 'dataEngagement', 'onCloseModal', 'updateTableData'],
    {
        dataEngagement: {
            type: Object
        },
        viewModal: {
            type: Boolean,
            default: false,
        },
        onCloseModal: {
            type: Function
        },
        updateTableData: {
            type: Function,
        },
    },
    mounted() {
        this.getRoleAndDutyList()
    },
    components: {
    },
    methods: {
        addItemEdit() {
            this.formData.items.push(
                {
                    'item_detail': '',
                    'amount': 0,
                    'isNewData': true
                }
            )
        },
        onRemoveItem(item, index) {
            if (!item.isNewData) {
                //console.log('old data')
                this.formData.items.splice(index, 1);
                this.listDeleteItem.push(item.id)
            } else {
                //console.log('new data')
                this.formData.items.splice(index, 1);
            }
        },
        async getRoleAndDutyList() {
            this.optionRoleAndDuty = [];
            try {
                const res = await this.$http.get(
                    `/student_affair/role-and-duty-in-the-activity/`
                );
                if (res.status === 200) {
                    this.optionRoleAndDuty = res.data.map((item) => {
                        return {
                            value: item.id,
                            text: `${item.name_eng}`,
                        };
                    });
                }
            } catch (error) { }
        },
        async removeDonationItem(idDel) {
            return new Promise((resolve) => {
                try {
                    this.$http.delete(
                        `/student_affair/donation-item/${idDel}/`
                    ).then(
                        (res) => {
                            if (res.status === 204) {
                                resolve(true);
                            } else {
                                throw { res };
                            }
                        },
                        (error) => {
                            //console.log(error)
                            resolve(false)
                        })
                }
                catch (e) {
                    resolve(false)
                }
            }
            );
        },
        async updateDonationData(jsonData) {
            return new Promise((resolve) => {
                try {
                    this.$http.patch(
                        `/student_affair/donation-item/${jsonData.id}/`,
                        jsonData
                    ).then(
                        (res) => {
                            if (res.status === 200) {
                                resolve(true);
                            } else {
                                throw { res };
                            }
                        },
                        (error) => {
                            //console.log(error)
                            resolve(false)
                        })
                }
                catch (e) {
                    resolve(false)
                }
            }
            );
        },
        async createDonationData(jsonData) {
            return new Promise((resolve) => {
                try {
                    this.$http.post(
                        `/student_affair/donation-item/`,

                        {
                            "item_detail": jsonData.item_detail,
                            "amount": jsonData.amount
                        }
                    ).then(
                        (res) => {
                            if (res.status === 201) {
                                resolve(res.data.id);
                            } else {
                                throw { res };
                            }
                        },
                        (error) => {
                            //console.log(error)
                            resolve(null)
                        })
                }
                catch (e) {
                    resolve(null)
                }
            }
            );
        },
        async onUpdateEngagement() {
            this.isLoaded = false;
            let listDeleteItem = this.listDeleteItem
            let listNewItem = this.formData.items.filter((data) => data.isNewData)
            let listUpdateItem = this.formData.items.filter((data) => !data.isNewData)
            let listUpdateItemID = []
            // remove item data
            for (let i = 0; i < listDeleteItem.length; i++) {
                await this.removeDonationItem(listDeleteItem[i]);
            }
            // update donation data  
            for (let i = 0; i < listUpdateItem.length; i++) {
                let isUpdate = await this.updateDonationData(listUpdateItem[i]);
                if (isUpdate) listUpdateItemID.push(listUpdateItem[i].id)
            }
            // add new donation data 
            for (let i = 0; i < listNewItem.length; i++) {
                let lastID = await this.createDonationData(listNewItem[i]);
                if (lastID) listUpdateItemID.push(lastID)
            }
            //console.log(this.formData)
            // update engagement record
            let jsonEngagementData = {
                "role_and_duty_in_the_activity_other": this.formData.other_role,
                "amount_fee": this.formData.donation_fee,
                "amount_sponsorship": this.formData.donation_sponsorship,
                "amount_charity": this.formData.donation_charity,
                "role_and_duty_in_the_activity": this.formData.role_and_duty,
                "item": listUpdateItemID,
            }
            try {
                this.$http.patch(
                    "/student_affair/engagement-record/" + this.formData.id + "/",
                    jsonEngagementData
                ).then(
                    (res) => {
                        if (res.status === 200) {
                            let updateData = res.data
                            let idRecordTable = this.formData.id_rec_table
                            this.$emit('updateTableData', { updateData, idRecordTable })
                            this.$notification['success']({
                                message: function (h) {
                                    return h("div", [
                                        h("strong", { class: "" }, `Updated data successfully`),
                                    ]);
                                },
                            });
                            this.isLoaded = true;
                            this.onCloseModal()
                        } else {
                            throw { res };
                        }
                    },
                    (error) => {
                        // //console.log(error)
                        this.$notification['error']({
                            message: function (h) {
                                return h("div", [
                                    h("strong", { class: "" }, `Failed to connect to the API`),
                                ]);
                            },
                            description:
                                `Error ${error.response.status} : /student_affair/engagement-record/`,
                        });
                    })
            }
            catch (e) {
                this.isLoaded = true;
                //console.log(e)
                this.$notification['error']({
                    message: function (h) {
                        return h("div", [
                            h("strong", { class: "" }, `Failed to connect to the API`),
                        ]);
                    },
                    description:
                        `Error ${error.response.status} : /student_affair/engagement-record/`,
                });
            }
        }
    },
    data() {
        return {
            // formData: null,
            isLoaded: true,
            formData: JSON.parse(JSON.stringify(this.dataEngagement)),// Object.assign({}, this.dataEngagement),
            //options
            optionRoleAndDuty: [],
            listDeleteItem: []
        };
    }
}
</script>